import React from 'react';
import classnames from 'classnames';
import StatusViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Status';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import TextRenderer from '../../../TextRenderer';
import { FullViewProps } from '../types';
import { getIsShortStatus, getStatusBackgroundProps } from '../../_helpers';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import Background from '../../../Background';
import SubPaywall from '../_partials/SubPaywall';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import s from './Status.scss';

export const StatusFullView: React.FC<FullViewProps> = ({
  deviation: { textContent },
  deviation,
  width,
}) => {
  const backgroundProps: any = getStatusBackgroundProps(deviation);
  const { isSubscribedButBlocked, needsSubscription } = useSubscriptionTier(deviation);
  const isBlocked = needsSubscription || isSubscribedButBlocked;

  if (isBlocked) {
    return <SubPaywall deviation={deviation} isStatusArtStage />;
  }

  if (!textContent) {
    return null;
  }

  if (!textContent || !(textContent.excerpt || textContent.html.markup)) {
    return null;
  }

  // Display logic
  // Legacy gets its own styles
  // If any media inserted it cant be short
  const isLegacy = textContent.html.type === 'writer';
  const isShortStatus = getIsShortStatus(deviation);
  const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);

  return (
    <div
      className={classnames(s['root'], isLegacy && s['legacy'], isShortStatus && s['short-status'])}
    >
      {isExtendedLoaded && (
        <>
          {backgroundProps && (
            <Background
              className={s['background-wrapper']}
              width={width}
              variant="status"
              {...backgroundProps}
            />
          )}
          <TextRenderer
            textContent={textContent}
            className={s['text']}
            legacyTheme={isShortStatus ? 'short-status' : 'status'}
            viewerKey={deviation.deviationId}
            tipTapViewer={StatusViewer}
            tipTapPresetId={isShortStatus ? 'deviation-status-short' : 'deviation-status'}
            cookieType={MeasuredCookieType.EDITOR_STATUS}
            defaultSize={{
              desktop: { width: 780, height: 512 },
              mobile: { width: 380, height: 300 },
            }}
          />
        </>
      )}
      {!isExtendedLoaded && <LoadingIndicator view="llama" coverMode />}
    </div>
  );
};
StatusFullView.displayName = 'StatusFullView';

export default StatusFullView;
